<template>
  <v-card class="mx-auto" tile :loading="laden">
    <v-system-bar color="indigo darken-2" dark>
      <v-spacer></v-spacer>
      <span></span>
    </v-system-bar>

    <v-toolbar color="indigo" dark>
      <v-toolbar-title>Gedicht - Deel 3</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon @click="sheet = true">
        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>
    </v-toolbar>
    <v-layout>
      <v-container fluid>
        <br />
        <p style="margin-left: 10px;">
          Later kunnen er meer opdrachten komen,<br />
          misschien kan je ’s nachts niet meer dromen.
          <br />
          Maar afijn, laten we verder gaan,<br />
          wat vind je bijvoorbeeld van je baan?<br />
          Mensen prikken, en het bloed dan onderzoeken,<br />
          dat staat niet in de kinderboeken.<br />
          <br />
          Verder wandel je graag,<br />
          zoals met mama, en zeker niet traag.<br />
          En anders met tante Alida en de hond,<br />
          dan blijf je immers gezond.
        </p>
      </v-container>
    </v-layout>
    <div class="text-center">
      <v-bottom-sheet v-model="sheet" persistent>
        <v-sheet class="text-center">
          <div class="py-3">
            <img src="/IbKAad.png" style="width: 500px;" /><br />
            
            <b>Wat moet er op de plek van de <u>?</u> staan?</b>
            <br />
            <br />
            <p class="grey--text">
              Noem het antwoord hardop om <span @click="next">door</span> te
              gaan.
            </p>
          </div>
        </v-sheet>
      </v-bottom-sheet>
    </div>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    time: "",
    laden: false,
    sheet: false,
  }),
  methods: {
    next() {
      this.$router.push({ name: "Deel4" });
    },
  },
  computed: {},
  mounted() {
    let SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;
    let recognition = SpeechRecognition ? new SpeechRecognition() : false;

    recognition.lang = "nl";
    recognition.interimResults = true;

    recognition.addEventListener("result", (event) => {
      const text = Array.from(event.results)
        .map((result) => result[0])
        .map((result) => result.transcript)
        .join("");
      this.time = text.split(" ").pop();
      if (text.includes("gezond")) {
        this.sheet = true;
      }
      if (text.includes("25") && this.sheet == true) {
        this.$router.push({ name: "Deel4" });
      }
    });

    recognition.addEventListener("end", () => {
      if (this.$route.name == "Deel3") {
        recognition.start();
      }
    });
    recognition.start();
  },
};
</script>
